var _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdventage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 35,
    viewBox: "0 0 44 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.878 10.4359V28.8324C14.878 29.187 15.1654 29.4743 15.52 29.4743C17.502 29.4743 19.1088 27.8676 19.1088 25.8855V10.4359H21.6473L16.9934 3.66666L11.9165 10.4359H14.878Z",
    fill: "#81168C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.045 6.76923V28.5504C35.045 28.9049 35.3324 29.1923 35.6869 29.1923C37.669 29.1923 39.2758 27.5855 39.2758 25.6035V6.76923H41.8143L37.1604 0L32.0835 6.76923H35.045Z",
    fill: "#81168C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.878 15.9359V28.8324C25.878 29.187 26.1654 29.4743 26.52 29.4743C28.502 29.4743 30.1088 27.8676 30.1088 25.8855V15.9359H32.6473L27.9934 9.16666L22.9165 15.9359H25.878Z",
    fill: "#81168C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79503 22.3526V28.4799C4.79503 28.8344 5.08243 29.1218 5.43694 29.1218C7.41902 29.1218 9.0258 27.515 9.0258 25.5329V22.3526H11.5643L6.91042 15.5833L1.8335 22.3526H4.79503Z",
    fill: "#81168C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.461538,
    y: 31.0641,
    width: 43.0769,
    height: 3.30769,
    rx: 0.461538,
    fill: "#81168C",
    stroke: "#81168C",
    strokeWidth: 0.923077
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdventage1);
export default __webpack_public_path__ + "static/media/adventage_1.94ed8a09167aac44a7210265535372d0.svg";
export { ForwardRef as ReactComponent };